export const GLOBAL_WIDTH = 2048;
export const GLOBAL_HEIGHT = 1536;
